const link = {
  methods: {
    openLink(url) {
      // eslint-disable-next-line no-debugger
      debugger
      const link = document.createElement('a');      
      link.target = '_blank';
      link.href = url;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  },
}

export default link;